import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

const TYPES = ["variance", "damaged", "expired", "theft", "overstock", "slow_moving"];

export default function Inventory() {
  const [branches, setBranches] = useState([]);
  useEffect(() => { api.get("/branches").then(({ data }) => setBranches(data)); }, []);
  return (
    <ResourcePage
      endpoint="/inventory"
      testidPrefix="inventory"
      eyebrow="Operations"
      title="Inventory & Stock Incidents"
      subtitle="Track stock variance, damaged goods, expired products, theft, overstock and slow-moving alerts."
      ctaLabel="Log stock incident"
      fields={[
        { name: "product_name", label: "Product name", required: true },
        { name: "sku", label: "SKU / Barcode" },
        { name: "type", label: "Incident type", type: "select", required: true, options: TYPES, default: "variance" },
        { name: "branch", label: "Branch", type: "select", required: true, options: branches.map((b) => b.name) },
        { name: "quantity", label: "Quantity", type: "number" },
        { name: "unit", label: "Unit", default: "pcs" },
        { name: "estimated_loss", label: "Estimated loss (UGX)", type: "number" },
        { name: "description", label: "Description / cause", type: "textarea" },
        { name: "status", label: "Status", type: "select", default: "open",
          options: ["open", "investigating", "resolved"] },
      ]}
      columns={[
        { key: "product_name", label: "Product" },
        { key: "type", label: "Type", render: (i) => <Badge tone={i.type === "theft" ? "red" : i.type === "expired" ? "amber" : "slate"}>{(i.type || "").replaceAll("_", " ")}</Badge> },
        { key: "branch", label: "Branch" },
        { key: "quantity", label: "Qty", render: (i) => `${i.quantity || 0} ${i.unit || ""}` },
        { key: "estimated_loss", label: "Loss", render: (i) => i.estimated_loss ? `UGX ${Number(i.estimated_loss).toLocaleString()}` : "—" },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "resolved" ? "emerald" : i.status === "investigating" ? "blue" : "amber"}>{i.status}</Badge> },
      ]}
      searchKeys={["product_name", "sku", "branch", "description"]}
    />
  );
}
